export default {
  "pages.home.title": "Accueil",
  "pages.albums.title": "Produits",
  "pages.albums.create.title": "Ajouter un produit",
  "pages.tracks.title": "Tracks",
  "pages.artists.title": "Artistes",
  "pages.login.title": "Se connecter",
  "pages.not-found.title": "Page non trouvée",
  "pages.statements.title": "Relevés",
  "pages.reports.title": "Rapports",
  "pages.reports.create.title": "Générer un rapport",
  "pages.users.title": "Utilisateurs",
  "pages.users.create.title": "Créer un utilisateur",
  "pages.deliveries.title": "Livraisons",
  "pages.deliveries.intro": "Suivre les activités de livraison de chaque fournisseur de services.",
  "pages.bundles.title": "Paquets",
  "pages.playlists.title": "Playlists",
  "pages.statistics.title": "Statistiques",
  "pages.bundles.create.title": "Uploader un nouveau paquet",
  "pages.login.intro": "Vous devez se connecter d'accéder à Watamusic.",
  "pages.report.intro": "Localisez et téléchargez vos relevés mensuels.",
  "pages.report.info": "Depuis janvier 2024 Modulor ne conserve les relevés que pendant deux années plus l'année en cours.<br></br>Les relevés sont disponibles à partir de 2023 uniquement",
  "pages.search.title": "Résultats de recherche",
  "home.welcome-user": "Bienvenue, {name}",
  "nav.bundles.title": "À partir d'un paquet",
  "nav.albums.create-title": "Ajouter un produit",
  "copyright": "© 2025 Modulor / Watamusic",
  "not-found.title": "404 - Page non trouvée",
  "not-found.description": "Désolé, la page que vous recherchez n'existe pas.",


  "auth.login.email": "Addresse e-mail",
  "auth.login.password": "Mot de passe",
  "auth.login.login": "Se connecter",
  "auth.login.failed": "L'email d'utilisateur et le mot de passe que vous avez entrés ne correspondent pas à ceux présents dans nos fichiers. Veuillez vérifier et réessayer.",
  "auth.login.error": "Une erreur s'est produite lors de la tentative de connexion. Veuillez réessayer plus tard.",
  "auth.action.logout": "Se déconnecter",
  "users.blurb": "Créer et gérer des utilisateurs au sein de votre organisation",
  "users.create.button": "Créer un nouvel utilisateur",


  "api.general.file-upload": "Le fichier à télécharger",
  "api.button.download-ext": "Télécharger [.{ext}]",

  "dsps.settings.dsps-filter": "Filtrer par DSP",


  "localisation.lang.en": "Anglais",
  "localisation.lang.fr": "Français",
  "localisation.country.entity_singular": "Pays",
  "localisation.country.entity_plural": "Pays",
  "localisation.country.entity_definite_article": "le pays",
  "localisation.country.entity_demonstrative": "ce pays",
  "localisation.country.entity_indefinite_article": "un pays",
  "localisation.region.entity_singular": "Région",
  "localisation.region.entity_plural": "Région",
  "localisation.region.entity_definite_article": "la région",
  "localisation.region.entity_demonstrative": "cette région",
  "localisation.region.entity_indefinite_article": "une région",
  "localisation.region.columns.code": "Code de région",


  "reports.menu.financial": "Financier",
  "reports.custom_reports.intro": "Générer et télécharger des rapports financiers personnalisés",
  "reports.custom_reports.generate-button": "Générer un nouveau rapport",
  "reports.custom_reports.info": "Un seul rapport personnalisé peut être généré à la fois à l'aide du formulaire \"Créer un rapport\".<br></br>Vous pouvez choisir de générer un rapport avec le total pour chaque plateforme ou un rapport détaillé de l'ensemble des plateformes sur la période choisie.<br></br>Les rapports peuvent être générés pour une période allant jusqu'à deux années plus l'année en cours.",
  "reports.custom_reports.in_progress_error": "Vous ne pouvez générer qu'un seul rapport à la fois.",
  "reports.report.entity_singular": "Rapport",
  "reports.report.entity_plural": "Rapports",
  "reports.report.columns.period": "Période",
  "reports.report.columns.description": "Description",
  "reports.report.columns.status": "Statut",
  "reports.report.columns.type": "Type",
  "reports.report.columns.generated_by": "Généré par",
  "reports.report.columns.created_at": "Créé",
  "reports.report.columns.updated_at": "Mis à jour",
  "reports.statement_singular": "Relevé",
  "reports.statementPlural": "Relevés",

  "reports.table.month": "Mois",
  "reports.table.last_updated": "Dernière mis à jour",
  "reports.table.number_rows": "Nombre de lignes",
  "reports.table.amount_payable": "Montant payable",
  "reports.table.download": "Télécharger",
  "reports.general.load-more-reports": "Charger plus de rapports",
  "statements.general.load-more-statements": "Charger plus de statements",


  "users.user.entity_singular": "Utilisateur",
  "users.user.entity_definite_article": "l'utilisateur",
  "users.user.entity_demonstrative": "cet utilisateur",
  "users.user.entity_indefinite_article": "un utilisateur",
  "users.user.entity_plural": "Utilisateurs",

  "users.columns.name": "Nom",
  "users.columns.email": "Addresse e-mail",
  "users.columns.password": "Mot de passe",
  "users.columns.organisation": "Organisation",
  "users.columns.roles": "Rôles",
  "users.columns.created_at": "Créé",
  "users.columns.updated_at": "Mis à jour",


  "music.settings.albums-filter": "Filtrer par album",
  "music.general.new-artist": "Nouvel artiste",
  "music.general.draft": "Brouillon",
  "music.general.archived": "Archivé",
  "music.no-albums-title": "Vous n'avez pas encore créé de produits",
  "music.no-albums": "Ajouter un produit pour commencer",
  "music.products.add": "Ajouter un produit",
  "music.latest-albums": "Derniers produits créés",
  "music.product-information": "Informations sur le produit",
  "music.track-information": "Informations sur le track",
  "music.album.links": "Linkfire et playlists obtenues",
  "music.album.links-description": "Vous trouverez ci-dessous le lien de pré-save pour partager la sortie sur vos réseaux sociaux, ainsi que les playlists obtenues à partir du lundi suivant la sortie, avant 13h.",
  "music.album.entity_singular": "Produit",
  "music.album.entity_plural": "Produits",
  "music.album.entity_definite_article": "le produit",
  "music.album.entity_demonstrative": "ce produit",
  "music.album.entity_indefinite_article": "un produit",
  "music.album.columns.title": "Titre",
  "music.album.columns.title_version": "Version du titre",
  "music.album.columns.upc": "UPC/EAN",
  "music.album.columns.custom_id": "Référence catalogue",
  "music.album.columns.original_release_date": "Première date de sortie",
  "music.album.columns.preorder_date": "Date de précommande",
  "music.album.columns.release_date": "Date de sortie",
  "music.album.columns.comment": "Commentaire",
  "music.album.columns.comment-private": "Commentaire privé",
  "music.album.columns.preorder-preview": "Extrait durant la période de pré-commande",
  "music.album.columns.genre": "Genre",
  "music.album.columns.additional-genre": "Genre supplémentaire",
  "music.album.columns.label": "Label",
  "music.album.columns.price": "Prix",
  "music.album.columns.track-price": "Prix du track",
  "music.album.columns.created_at": "Créé",
  "music.album.columns.updated_at": "Mis à jour",

  "music.track.entity_singular": "Track",
  "music.track.entity_plural": "Tracks",
  "music.track.entity_definite_article": "le track",
  "music.track.entity_demonstrative": "ce track",
  "music.track.entity_indefinite_article": "un track",
  "music.track.columns.title": "Titre",
  "music.track.columns.title_version": "Version du titre",
  "music.track.columns.isrc": "ISRC",
  "music.track.columns.duration": "Durée",
  "music.track.columns.explicit": "Explicite",
  "music.track.columns.gapless": "Sans intervalle",
  "music.track.columns.genre": "Genre",
  "music.track.columns.label": "Label",
  "music.track.columns.artists": "Artiste(s)",
  "music.track.columns.copyright": "Droit d'auteur",
  "music.track.columns.albums": "Albums",
  "music.track.columns.created_at": "Créé",
  "music.track.columns.updated_at": "Mis à jour",

  "music.artist.entity_singular": "Artiste",
  "music.artist.entity_plural": "Artistes",
  "music.artist.entity_definite_article": "l'artiste",
  "music.artist.entity_demonstrative": "cet artiste",
  "music.artist.entity_indefinite_article": "un artiste",

  "music.album_track.columns.disc": "Disque",
  "music.album_track.columns.track": "Track",
  "music.album_track.columns.album_only": "Album uniquement",
  "music.album_track.columns.preorder_date": "Date de précommande",
  "music.album_track.columns.release_date": "Date de sortie",

  "music.label.entity_singular": "Label",
  "music.label.entity_plural": "Labels",
  "music.label.entity_definite_article": "le label",
  "music.label.entity_demonstrative": "ce label",
  "music.label.entity_indefinite_article": "un label",
  "music.label.columns.name": "Nom",


  "files.file.entity_singular": "Fichier",
  "files.file.entity_plural": "Fichiers",
  "files.file.entity_definite_article": "le fichier",
  "files.file.entity_demonstrative": "ce fichier",
  "files.file.entity_indefinite_article": "un fichier",


  "sales.general.load-more-playlists": "Charger plus de playlists",
  "sales.title": "Trends",
  "sales.title.performance": "Performance",
  "sales.info-popover.title": "Remarque",
  "sales.info-popover.body": "<p>La plage maximale sur laquelle vous pouvez effectuer une recherche est de {days} jours. Si vous avez besoin de données pour une plage plus large, veuillez contacter {provider}.</p><p>Les trends YouTube peuvent ne pas refléter les vues finales indiquées dans les statements. Ces chiffres doivent être traités uniquement à titre indicatif.</p>",
  "sales.playlist-trends.title": "Trends du playlist",
  "sales.playlist-trends.table.total": "Total streams",
  "sales.playlist-trends.table.tracks": "Tracks",
  "sales.blurb": "Pour le moment, cettes données montrent téléchargements d'iTunes et streams de Apple Music et Spotify seulement.",
  "sales.title.gender": "Répartition par sexe",
  "sales.title.age": "Répartition par âge",
  "sales.title.region": "Répartition par région",
  "sales.small.gender": "Les données provenant de Spotify et Apple Music seulement et peuvent ne pas correspondre exactement aux chiffres ci-dessus.",
  "sales.streams": "Streams",
  "sales.downloads": "Téléchargements",
  "sales.total": "Total",
  "sales.num-streams": "{number} {total, plural,\n =0 {stream}\n one {stream}\n other {streams}\n}",
  "sales.num-downloads": "{number} {total, plural,\n =0 {téléchargement}\n one {téléchargement}\n other {téléchargements}\n}",
  "sales.total-streams": "Total des streams sur cette période: {number} {total, plural,\n =0 {stream}\n one {stream}\n other {streams}\n}",
  "sales.total-streams-of-total": "Total des streams sur cette période: {number} {total, plural,\n =0 {stream}\n one {stream}\n other {streams}\n} ({percent} du total)",
  "sales.total-streams-no-value": "Total des streams sur cette période",
  "sales.total-streams-period": "Total des streams sur {period}",
  "sales.period.last-n-days": "les {n} derniers jours",
  "sales.total-downloads": "Total des téléchargements sur cette période: {number} {total, plural,\n =0 {téléchargement}\n one {téléchargement}\n other {téléchargements}\n}",
  "sales.total-downloads-of-total": "Total des téléchargements sur cette période: {number} {total, plural,\n =0 {téléchargement}\n one {téléchargement}\n other {téléchargements}\n} ({percent} du total)",
  "sales.total-downloads-no-value": "Total des téléchargements sur cette période",
  "sales.label.country": "Pays",
  "sales.graph.album_sales": "Ventes d'albums",
  "sales.graph.track_sales": "Ventes de tracks",
  "sales.graph.album-download": "Téléchargements d'albums",
  "sales.graph.track-download": "Téléchargements de tracks",
  "sales.graph.itunes-album-download": "iTunes albums",
  "sales.graph.itunes-track-download": "iTunes tracks",
  "sales.graph.track-stream": "Streams de tracks",
  "sales.graph.am-stream": "Apple Music",
  "sales.graph.spotify-stream": "Spotify",
  "sales.graph.deezer-stream": "Deezer",
  "sales.graph.napster-stream": "Napster",
  "sales.graph.youtube-stream": "YouTube",
  "sales.graph.youtube-subscription-stream": "YouTube Premium",
  "sales.graph.youtube-ad-stream": "YouTube Ad",
  "sales.graph.amazon-stream": "Amazon",
  "sales.graph.amazon-album-download": "Amazon albums",
  "sales.graph.amazon-track-download": "Amazon tracks",
  "sales.settings.country-filter": "Filtrer par pays",
  "sales.presets.last-30-days": "Les 30 derniers jours",
  "sales.presets.this-week": "Cette semaine",
  "sales.presets.last-week": "La semaine dernière",
  "sales.presets.previous-week": "La semaine précédente",
  "sales.presets.this-month": "Ce mois",
  "sales.presets.last-month": "Le mois dernier",
  "sales.presets.previous-month": "Le mois précédent",
  "sales.presets.last-3-months": "Les 3 derniers mois",
  "sales.presets.previous-3-months": "Les 3 mois précédents",
  "sales.presets.since-release-date": "Depuis la sortie",
  "sales.gender.male": "Homme",
  "sales.gender.female": "Femme",
  "sales.gender.unknown": "Inconnu",
  "sales.gender.neutral": "Neutre",
  "sales.age-group.unknown": "Inconnu",
  "sales.plus-additional-tracks": "+ Plus {number, plural, =0 {aucun track supplémentaire} one {# track supplémentaire} other {# tracks supplémentaires}}",
  "sales.number-streams": "#\xa0streams",
  "sales.headline-stats.new-releases": "Streams à partir des nouveautés",
  "sales.headline-stats.whole-catalogue": "Streams de tout le catalogue",
  "sales.headline-stats.playlists": "Streams à partir de playlist",
  "sales.headline-stats.tracked-playlists": "Streams à partir de  playlist suivies",
  "sales.dsp-streams-chart.title": "Streams par source",
  "sales.dsp-downloads-chart.title": "Téléchargements par source",
  "sales.geo-chart.title": "Performance par pays",

  "search.form.placeholder": "Rechercher",
  "search.form.placeholder-focused": "Recherchez d'albums par titre, UPC/EAN, etc.",
  "search.results.title": "Résultats de recherche pour \"{query}\"",
  "search.results.found": "Trouvé {total, plural,\n =0 {aucun résultats}\n other {{albums, plural,\n =0 {}\n one {un produit}\n other {# produits}\n} {tracks, plural,\n =0 {}\n one {{albums, plural, =0 {} other {et}} un track}\n other {{albums, plural, =0 {} other {et}} # tracks}\n}}\n}",
  "search.results.error": "Il faut entrer une requête de recherche.",


  "charts.title": "Tops",
  "charts.no-rows": "Il n'y a pas des rangées pour cet top.",
  "charts.num-streams": "{number} {total, plural,\n =0 {stream}\n one {stream}\n other {streams}\n}",
  "charts.num-downloads": "{number} {total, plural,\n =0 {téléchargement}\n one {téléchargement}\n other {téléchargements}\n}",
  "charts.new-releases-popover-title": "Les nouveautés",
  "charts.new-releases-description": "Les nouveautés correspondent aux produits sortis dans les 8 semaines de la période sélectionnée.",
  "charts.chart.stream-tracks-week": "Tracks les + streamés de la semaine",
  "charts.chart.stream-tracks-alltime": "Tracks les + streamés de tous les temps",
  "charts.chart.download-tracks-alltime": "Tracks les + téléchargés de tous les temps",
  "charts.chart.download-albums-week": "Produits les + téléchargés de la semaine",
  "charts.chart.download-albums-alltime": "Produits les + téléchargés de tous les temps",
  "charts.chart.stream-tracks-period": "Tracks les + streamés",
  "charts.chart.stream-newreleases-period": "Nouveautés les + streamées",
  "charts.chart.download-tracks-period": "Tracks les + téléchargés",
  "charts.chart.download-albums-period": "Produits les + téléchargés",
  "charts.chart.preorders-period": "Produits les + précommandés",
  "charts.chart.stream-artists-period": "Artistes les + streamés",


  "deliveries.general.load-more-deliveries": "Charger plus de livraisons",
  "deliveries.settings.type-filter": "Filtrer par type",
  "deliveries.settings.status-type-filter": "Filtrer par type de statut",
  "deliveries.type.insert": "Livraison",
  "deliveries.type.full-update": "Mise à jour complète",
  "deliveries.type.full-takedown": "Takedown",
  "deliveries.type.update-tracks": "Mise à jour les tracks",
  "deliveries.type.update-metadata": "Mise à jour les métadonnées",
  "deliveries.type.update-deal": "Mise à jour les contrats",
  "deliveries.status_type.selected": "Selectionné",
  "deliveries.status_type.scheduled-delivery": "Livraison programmée",
  "deliveries.status_type.delivery-in-progress": "Livraison en cours",
  "deliveries.status_type.delivered": "Livré",
  "deliveries.status_type.error": "Erreur",
  "deliveries.status_type.cancelled": "Annulé",
  "deliveries.status_type.not-available": "Indisponible",
  "deliveries.status_type.available": "Disponible",
  "deliveries.delivery.entity_singular": "Livraison",
  "deliveries.delivery.entity_plural": "Livraisons",
  "deliveries.delivery.entity_definite_article": "la livraison",
  "deliveries.delivery.entity_demonstrative": "cette livraison",
  "deliveries.delivery.entity_indefinite_article": "une livraison",
  "deliveries.delivery.columns.album": "Album",
  "deliveries.delivery.columns.upc": "UPC/EAN",
  "deliveries.delivery.columns.dsp": "DSP",
  "deliveries.delivery.columns.type": "Type",
  "deliveries.delivery.columns.status": "Statut",
  "deliveries.delivery.columns.batch": "Batch",
  "deliveries.delivery.columns.created_at": "Créé",
  "deliveries.delivery.columns.updated_at": "Mis à jour",
  "deliveries.status.columns.type": "Type",
  "deliveries.status.columns.occurred_at": "Eu lieu",
  "deliveries.batch.columns.name": "Nom du lot",
  "deliveries.batch.columns.file_structure": "Fichiers",


  "upload.general.load-more-bundles": "Charger plus de paquets",
  "upload.general.upload-new-bundle": "Uploader un Nouveau paquet",
  "upload.general.download-empty-metadata": "Télécharger le fichier métadonnées",
  "upload.general.upload-metadata": "Uploader métadonnées",
  "upload.general.upload": "Uploader",
  "upload.general.reupload-metadata": "Reuploader métadonnées",
  "upload.general.view-update": "Voir/mettre à jour",
  "upload.general.uploaded-by": "Uploadé par {name}",
  "upload.general.album-preview": "Aperçu de l'album",
  "upload.general.create-album": "Créer l'album",
  "upload.general.update-album": "Mettre à jour l'album",
  "upload.general.upload-zip": "Uploader le fichier zip",
  "upload.general.reupload-zip": "Re-uploader le dichier zip",
  "upload.general.confirmation": "Confirmation",
  "upload.general.complete": "Compléter",
  "upload.instructions.upload-1": "Pour uploader un nouveau paquet, vous devez télécharger le fichier métadonnées vide et le remplir.",
  "upload.instructions.upload-2": "Ensuite, cliquez sur \"uploader\" pour commencer le processus.",
  "upload.instructions.upload-3": "Pour télécharger le fichier métadonnées non macro activé <link>cliquez ici</link>.",
  "upload.instructions.create-album-1": "Vous trouverez ci-dessous une preview de l'album qui sera créé.",
  "upload.instructions.create-album-2": "Veuillez vérifier que toutes les informations sont correctes, et surtout celles concernant les artistes qui seront créés.",
  "upload.instructions.create-album-3": "Si les informations sont correctes, cliquer sur le bouton \"créer l'album et les artistes\".",
  "upload.instructions.upload-zip-1": "Ensuite vous devez uploader un dossier .zip avec les éléments suivants :",
  "upload.instructions.upload-zip-list-1": "Un fichier JPG ou PNG pour l'artwork. Ce doit un être un fichier 3000x3000 RVB JPG, sans embedded profiles",
  "upload.instructions.upload-zip-list-2": "Un fichier FLAC ou WAV de chaque track. Le nom du fichier doit être précédé de <strong>''[disc]_[track]_''</strong> pour que cela corresponde à la bonne track. Ex pour l''audio de la track 4 sur le disc 2 : <strong>''2_4_tracktitle.wav''</strong>",
  "upload.instructions.upload-zip-list-3": "Un fichier PDF du booklet (si besoin).",
  "upload.instructions.complete-1": "Pour compléter l'upload et créer l'album, veuillez confirmer que vous souhaitez continuer. Ensuite, l'audio va être traité, ce qui peut prendre un peu de temps.",
  "upload.instructions.complete-2": "Attention",
  "upload.instructions.complete-3": "L'upload est maintenant à l'étape finale. Une fois cela fait, vous ne pourrez plus revenir aux étapes précédentes pour modifier les métadonnées ou le contenu. Pour terminer, cliquez lorsque que vous êtes sûr que tout est correct. Accordez nous également suffisamment de temps pour que l'album soit envoyé aux DSPs, au moins une semaine avant la sortie.",
  "upload.instructions.error-1": "Le paquet contient une erreur. Veuillez contacter le service client pour résoudre le problème.",
  "upload.instructions.error-2": "Nous avons constaté les erreurs suivantes :",
  "upload.bundle.default-title": "Paquet {id}",
  "upload.bundle.entity_singular": "Paquet",
  "upload.bundle.entity_plural": "Paquets",
  "upload.bundle.entity_definite_article": "le paquet",
  "upload.bundle.entity_demonstrative": "se paquet",
  "upload.bundle.entity_indefinite_article": "un paquet",
  "upload.bundle.columns.attrs": "Attributs",
  "upload.bundle.columns.errors": "Erreurs",
  "upload.bundle.columns.status": "Statut",
  "upload.bundle.columns.album": "Album",
  "upload.bundle.columns.user": "Uploadé par",
  "upload.bundle.columns.created_at": "Crée",
  "upload.bundle.columns.updated_at": "Mis à jour",


  "vendor.settings.playlists-filter": "Sélectionner une playlist",
  "vendor.settings.snapshot_taken": "Instantané pris le {date}",
  "vendor.settings.go_to_track": "Aller au track",
  "vendor.settings.go_to_playlist": "Aller à la playlist",
  "vendor.settings.no_snapshots": "Il n'y a pas d'instantané à afficher.",
  "vendor.title.tracks_on_playlists": "Tracks actuellement en playlist",
  "vendor.playlist.default-title": "Playlist {id}",
  "vendor.playlist.entity_singular": "Playlist",
  "vendor.playlist.entity_plural": "Playlists",
  "vendor.playlist.entity_definite_article": "la playlist",
  "vendor.playlist.entity_demonstrative": "cette playlist",
  "vendor.playlist.entity_indefinite_article": "une playlist",
  "vendor.playlist.listen_on": "Écouter sur {vendor}",
  "vendor.playlist-snapshot.entity_singular": "Instantané du playlist",
  "vendor.playlist-snapshot.entity_plural": "Instantanés de playlist",
  "vendor.playlist-snapshot.entity_definite_article": "'l'instantané du playlist",
  "vendor.playlist-snapshot.entity_demonstrative": "cet instantané du playlist",
  "vendor.playlist-snapshot.entity_indefinite_article": "un instantané du playlist",
  "vendor.playlist-snapshot.columns.num_followers": "Nombre d'abonnés",
  "vendor.playlist-snapshot.columns.meta.updated_at": "Mis à jour",
  "vendor.playlist-snapshot.columns.num_owned_tracks": "Tracks de votre catalogue sur playlist",
  "vendor.playlist.columns.meta.owner": "Créé par",
  "vendor.track.entity_singular": "Track",
  "vendor.track.entity_plural": "Tracks",
  "vendor.track.entity_definite_article": "le track",
  "vendor.track.entity_demonstrative": "ce track",
  "vendor.track.entity_indefinite_article": "un track",
  "vendor.track.columns.title": "Titre",
  "vendor.track.columns.artists": "Artiste(s)",
  "vendor.track.columns.album": "Album",
  "vendor.track.columns.isrc": "ISRC",
  "vendor.track.columns.vendor": "Service",
  "vendor.track.columns.playlists": "Playlists",
  "vendor.playlist-snapshot-track.columns.added_at": "Ajouté",




  "ui.pages.home": "Accueil",
  "ui.dates.day": "Jour",
  "ui.dates.month": "Mois",
  "ui.dates.year": "Année",
  "ui.dates.start": "Date de début",
  "ui.dates.end": "Date de fin",
  "ui.async.loading": "Chargement",
  "ui.async.load-more": "Charger plus",
  "ui.button.download": "Télécharger",
  "ui.button.download-csv": "Télécharger CSV",
  "ui.button.create": "Créer",
  "ui.button.delete": "Supprimer",
  "ui.button.edit": "Modifier",
  "ui.button.update": "Mettre à jour",
  "ui.button.yes": "Oui",
  "ui.button.no": "Non",
  "ui.button.show-more": "Montrer plus",
  "ui.button.show-fewer": "Montrer moins",
  "ui.select.add_label": "Ajouter \"{label}\"?",
  "ui.select.clear_all": "Tout effacer",
  "ui.select.clear_value": "Valeur effacer",
  "ui.select.no_results": "Aucun résultat trouvé",
  "ui.select.placeholder": "Sélectionner...",
  "ui.select.search_prompt": "Tapez pour rechercher",
  "ui.select.loading": "Chargement...",
  "ui.phrases.create_entity": "Créer {entity}",
  "ui.phrases.edit_entity": "Modifier {entity}",
  "ui.phrase.delete_entity": "Supprimer {entity}",
  "ui.phrase.delete_entity_long": "Etes-vous sûr de vouloir supprimer {entity}, \"{name}\"?",

  "table.filter": "Filtrer",
  "table.manage": "Gérer",
  "table.reset-filters": "Réinitialiser les filtres",
  "table.filter-placeholder": "Commencer à taper pour filtrer...",

  "pagination.previous": "Précédent",
  "pagination.next": "Suivant",


  "validation.mesages.required": "Le champ {column} est obligatoire.",
  "validation.mesages.min_length": "Le texte {column} doit contenir au moins {min} caractères.",
  "validation.mesages.max_length": "Le texte de {column} ne peut contenir plus de {max} caractères.",
  "validation.mesages.email": "Le champ {column} doit être une adresse e-mail valide.",
  "validation.mesages.min": "La valeur de {column} doit être supérieure ou égale à {min}.",
  "validation.mesages.max": "La valeur de {column} ne peut être supérieure à {max}.",
  "validation.mesages.pattern": "Le champ {column} doit correspondre au modèle {pattern}.",
  "validation.mesages.equal_to": "Le champ {column} doit correspondre {match}.",
  "validation.mesages.one_of": "Le champ {column} doit être l'un des {matches}.",
  "validation.mesages.url": "Le format de l'URL de {column} n'est pas valide."
};
